export enum DeviceState {
    ON = 'ON',
    OFF = 'OFF',
    STANDBY = 'STANDBY',
    ONLINE = 'ONLINE',
}
